var map = {
	"./Contact": [
		5245,
		245
	],
	"./Contact/": [
		5245,
		245
	],
	"./Contact/index": [
		5245,
		245
	],
	"./Contact/index.tsx": [
		5245,
		245
	],
	"./Contact/styles": [
		2334,
		334
	],
	"./Contact/styles.tsx": [
		2334,
		334
	],
	"./Home": [
		332,
		332
	],
	"./Home/": [
		332,
		332
	],
	"./Home/index": [
		332,
		332
	],
	"./Home/index.tsx": [
		332,
		332
	],
	"./Home/styles": [
		5985,
		985
	],
	"./Home/styles.tsx": [
		5985,
		985
	],
	"./Home1": [
		4280,
		280
	],
	"./Home1/": [
		4280,
		280
	],
	"./Home1/index": [
		4280,
		280
	],
	"./Home1/index.tsx": [
		4280,
		280
	],
	"./Home1/styles": [
		8560,
		560
	],
	"./Home1/styles.tsx": [
		8560,
		560
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;